import { cn } from "@/modules/lib/utils"
import { cva, type VariantProps } from "class-variance-authority"

const labelVariants = cva(
  "flex items-center gap-1 select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "text-textDefault-body",
        inside: "absolute top-3.5 left-4 z-50 text-textDefault-placeholder",
      },
      fontStyle: {
        LL: "label-large",
        LM: "label-medium",
        LS: "label-small",
      },
    },
    defaultVariants: {
      variant: "default",
      fontStyle: "LM",
    },
  },
)

function Label({
  className,
  variant,
  fontStyle,
  ...props
}: React.ComponentProps<"label"> & VariantProps<typeof labelVariants>) {
  return (
    <label data-slot="label" className={cn(labelVariants({ variant, fontStyle, className }))} {...props} />
  )
}

export { Label }
